import React, { useState, useEffect } from "react";
import sidebarItems from "../../components/utils/sidebarItems";
import { Link, useLocation } from "react-router-dom";
import { FiLogOut } from "react-icons/fi";
import { LOGOUT } from "../../store/actions/authenticationAction";
import { t } from "i18next";
import { bioLogout } from "../../db/BioStar/APIs";
import { handleLoading } from "../../store/actions/loadingAction";
import { useSelector } from "react-redux";
import numeral from "numeral";
import { LANGUAGES } from "../../routes/Routes";
import useSWR from "swr";
import { fetcher } from "../../components/UI/TableView/ShowPaginationData";


function SideBar({ onChangeLanguage, currentLanguage }) {
  const [activeIndex, setActiveIndex] = useState(0);
  const location = useLocation();
  const currentAdmin = useSelector((state) => state.authentication.user);
  const currentPrice = useSelector((state) => state.dollarPrices?.currentPrice)
  const currentCenterId = JSON.parse(localStorage.getItem("centerId")).centerId

  const [toggle, setToggle] = useState(false);
  // const requests = useSelector(state => state.requests?.requests)
  const { data: requests, isLoading, error } = useSWR('/requests?status=0&onlyLength=true&centerId=' + currentCenterId, fetcher)
  const onHandleToggle = () => {
    setToggle(!toggle);
  };

  useEffect(() => {
    const curPath = window.location.pathname.split("/")[1];
    if (!curPath) {
      setActiveIndex(0);
      return;
    }
    const activeItem = sidebarItems.findIndex(
      (item) => item.section === curPath
    );
    setActiveIndex(curPath.length === 0 ? 0 : activeItem);
  }, [location]);

  return (
    <div style={{
      width: "30%",
      maxWidth: 240,
      minWidth: 180,
    }}  >
      <div
        style={{
          width: "30%",
          maxWidth: 240,
          minWidth: 180,
          height: "100%",
          zIndex: 20,
        }}
        className="fixed bg-[#090E14]"
      >
        <select onChange={onChangeLanguage} value={currentLanguage} style={{ width: '100%', backgroundColor: '#f7f7f7', height: 30 }} >
          {LANGUAGES.map((item, index) => {
            return (
              <option value={item.lang} key={index} style={{ textTransform: 'uppercase' }}  >{item.label}</option>
            )
          })}
        </select>
        {currentPrice&&currentAdmin.type!==3 && <>

          <div className="p-2 pt-2 font-mono font-bold text-center text-white capitalize bg-white/10 border-b-whiteCardIndexColor" style={{ borderBottomWidth: 1, fontSize: 15 }}>
            {t('buy')} $ = {numeral(currentPrice?.price * 1 - 1000).format("0,0")}
          </div>
          <div className="p-2 pt-2 font-mono text-base font-bold text-center text-white capitalize bg-white/10 border-b-whiteCardIndexColor" style={{ borderBottomWidth: 1, fontSize: 15 }}>
            {t('sell')} $ = {numeral(currentPrice?.price * 1 + 1500).format("0,0")}
          </div>
        </>}
        <div >
          {sidebarItems.map((item, index) => {
            if (item.type.includes(currentAdmin.type))
            
              return (
                <Index
                  key={index}
                  item={item}
                  toggle={toggle}
                  badgeIcon={item.section === 'requests' && requests && requests > 0 ? requests : null}
                  isActive={activeIndex === index}
                  onHandleToggle={onHandleToggle}
                />
              );
          })}
        </div>
        <LogoutButton />
      </div>
      <div
        style={{
          width: "30%",
          maxWidth: 240,
          minWidth: 180,
          zIndex: 10,
          height: "100%",
        }}
      />
    </div>
  );
}

const Index = ({ item, isActive, toggle, badgeIcon, onHandleToggle }) => {
  return (
    <Link
      onClick={() => (toggle ? onHandleToggle() : null)}
      to={item.to}
      className={`flex w-full relative h-12 mb-3 justify-start items-center  cursor-pointer text-center  hover:opacity-80 px-10 ${isActive ? "bg-whiteCardIndexColor" : ""
        }`}
    >
      {item.icon}
      {badgeIcon && <div style={{ height: 15, fontSize: 11, fontFamily: 'Montserrat-Bold', width: 15 }} className="absolute top-0 flex items-center justify-center ml-2 font-bold text-white bg-red-600 rounded-full" >{badgeIcon}</div>}
      <div className="" >
        <p className="ml-8 font-normal text-mainWhite">{t(item.display)}</p>
      </div>
    </Link>
  );
};

const LogoutButton = () => {
  const onLogout = async () => {
    handleLoading();
    await bioLogout();
    LOGOUT();
  };

  return (
    <button
      onClick={onLogout}
      className={`flex w-full h-12  mt-3 justify-start items-center cursor-pointer text-center  hover:opacity-80 px-10 absolute bottom-10`}
    >
      <FiLogOut color="#fff" size={22} className="mx-1" />
      <p className="ml-8 font-bold text-mainWhite">{t("logout")}</p>
    </button>
  );
};
export default SideBar;
